module.exports = __webpack_public_path__ + "img/ai.0d404764.png";